export enum CalToggle {
  Open = 1,
  CloseByDateSel = 2,
  CloseByCalBtn = 3,
  CloseByOutClick = 4,
  CloseByEsc = 5,
}
